import apiClient from '../config/api';

// Contact Service - envia dados do formulário para o backend
const contactService = {
  async sendMessage({ name, email, phone, subject, message }) {
    const payload = { name, email, phone, subject, message };
    const response = await apiClient.post('/contact', payload);
    return response;
  }
};

export default contactService;